import { useDispatch } from 'react-redux';
import { removePreferredEntityNotifications, savePreferredEntityNotification } from '../../store/actions/user';

export default (isNotifying, entityField, entity) => {
  const dispatch = useDispatch();
  const action = isNotifying ? removePreferredEntityNotifications : savePreferredEntityNotification;

  return () => dispatch(action(entityField, entity.id));
};
